import APIs from '../../apiUrl';

const contactSubmission = async (payload) => {
  try {
    const response = await APIs.post(`/contact_us`, payload);
    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const contactServices = {
  contactSubmission,
};

export default contactServices;
